import { ISmartFieldChange } from "@components/smart/smartField/SmartField";
import {
    IPrCSSZSubmissionIllnessLeaveEntity,
    IPrCSSZSubmissionMaternityLeaveEntity
} from "@odata/GeneratedEntityTypes";
import { PrSubmissionSubtypeCode, PrSubmissionTypeCode } from "@odata/GeneratedEnums";
import {
    handleIsCaringPersonallyChange,
    initHasPensionLocalPath,
    pensionBeforeSaveAdjustments
} from "@pages/payroll/submission/submissionTypes/PrCSSZSubmission.utils";
import PrCSSZSubmissionNEMPRIFormView from "@pages/payroll/submission/submissionTypes/PrCSSZSubmissionNEMPRIFormView";

import { withPermissionContext } from "../../../../contexts/permissionContext/withPermissionContext";

class PrCSSZSubmissionIllnessLeaveFormView extends PrCSSZSubmissionNEMPRIFormView<IPrCSSZSubmissionIllnessLeaveEntity> {
    typeCode = PrSubmissionTypeCode.EmployersNotificationOfAnEmployeesBenefitApplication;
    subTypeCode = PrSubmissionSubtypeCode.NempriIllnessLeave;

    typeSpecificOnAfterLoad(isNew: boolean): Promise<void> {
        const { storage } = this.props;

        initHasPensionLocalPath(storage);

        return super.typeSpecificOnAfterLoad(isNew);
    }

    handleChange(e: ISmartFieldChange) {
        handleIsCaringPersonallyChange(e, this.props.storage);
        super.handleChange(e);
    }

    onBeforeSave(data?: IPrCSSZSubmissionMaternityLeaveEntity): IPrCSSZSubmissionMaternityLeaveEntity {
        data = super.onBeforeSave(data);

        return pensionBeforeSaveAdjustments(data, this.props.storage);
    }
}

export default withPermissionContext(PrCSSZSubmissionIllnessLeaveFormView);